var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7587_10309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7587_10309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3886 15.199C19.3886 12.9793 19.3878 10.7589 19.3863 8.53798C19.3863 8.15596 19.2302 8.00422 18.8411 8.00157C18.3237 7.99804 17.8063 8.00157 17.2894 8.00157C16.8431 8.00157 16.6923 8.14185 16.7045 8.58342C16.7099 8.75987 16.6595 8.8331 16.4795 8.88427C14.6574 9.40568 12.8374 9.9343 11.0195 10.4701C10.6106 10.5901 10.5494 10.688 10.5498 11.1014C10.5498 12.0322 10.5498 12.9634 10.5498 13.8942C10.5498 14.0742 10.5296 14.2912 10.5948 14.4641C10.6799 14.6869 10.9858 14.7081 11.1919 14.7681L11.6499 14.9004C12.0471 15.0142 12.403 15.1143 12.7562 15.2206C12.7636 15.2231 12.7705 15.2267 12.7769 15.2312L13.8305 15.54C13.9281 15.5647 13.9776 15.5758 14.0262 15.5899C14.8297 15.8228 15.6315 16.0606 16.4372 16.2851C16.6275 16.3385 16.718 16.406 16.7072 16.6248C16.6847 17.0262 16.8592 17.1806 17.2741 17.1815C17.7911 17.1815 18.3082 17.1815 18.8253 17.1815C19.2275 17.1815 19.3836 17.028 19.3863 16.6358C19.3899 16.1563 19.3886 15.6768 19.3886 15.199ZM16.6892 15.4637C15.9154 15.2405 15.1622 15.0226 14.41 14.8055C13.485 14.5373 12.5609 14.2638 11.6346 14C11.4928 13.9599 11.4267 13.9118 11.4289 13.7512C11.4388 12.9722 11.4366 12.1927 11.4289 11.4133C11.4289 11.2809 11.4703 11.2205 11.5981 11.1834C13.269 10.7011 14.9392 10.2169 16.6087 9.7308C16.635 9.72778 16.6615 9.72778 16.6878 9.7308L16.6892 15.4637ZM18.4964 16.3019H17.5845V8.86486H18.496L18.4964 16.3019Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86831 12.5985C9.86831 13.1279 9.87056 13.6546 9.86831 14.183C9.86831 14.5024 9.705 14.6828 9.43191 14.6802C9.15882 14.6776 9 14.4967 9 14.1769C9 13.1055 9 12.0343 9 10.9632C9 10.7136 9.12192 10.5556 9.33878 10.5089C9.54708 10.4648 9.71444 10.5349 9.81027 10.7171C9.85124 10.8106 9.87031 10.9119 9.86606 11.0135C9.87146 11.542 9.86831 12.07 9.86831 12.5985Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2922 11.1712C20.0978 11.154 19.9484 11.0874 19.8769 10.9065C19.809 10.7341 19.8319 10.5761 19.9669 10.4425C20.0099 10.3997 20.0601 10.3645 20.1153 10.3384C20.7227 10.0384 21.3301 9.73622 21.9401 9.44463C22.1759 9.33214 22.4319 9.41684 22.5421 9.62108C22.6523 9.82533 22.574 10.0812 22.3365 10.2012C21.7066 10.5192 21.0691 10.824 20.4339 11.1324C20.3881 11.15 20.3406 11.1631 20.2922 11.1712Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.296 14.0117C20.374 14.0303 20.4505 14.055 20.5245 14.0854C21.1094 14.3673 21.6902 14.65 22.2697 14.939C22.5239 15.0656 22.6247 15.2416 22.581 15.441C22.519 15.7229 22.2513 15.8711 21.9804 15.7436C21.3416 15.4436 20.7086 15.1313 20.0782 14.8146C19.9854 14.7712 19.9121 14.6958 19.8724 14.6028C19.8326 14.5098 19.8292 14.4057 19.8627 14.3104C19.9262 14.1224 20.0715 14.0325 20.296 14.0117Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7631 13.0187C21.5161 13.0187 21.2682 13.0253 21.0212 13.0187C20.7324 13.009 20.5533 12.8378 20.5547 12.5886C20.556 12.3393 20.7378 12.1646 21.0239 12.1611C21.526 12.1546 22.0281 12.1546 22.5302 12.1611C22.8105 12.1642 22.999 12.3477 22.9986 12.593C22.9981 12.8382 22.8132 13.0134 22.5275 13.0217C22.2733 13.0297 22.0182 13.0217 21.7627 13.0217L21.7631 13.0187Z",
    fill: "#FF4F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0416 18.9989H12.4795C12.3007 18.9983 12.1294 18.9284 12.003 18.8045C11.8766 18.6805 11.8053 18.5125 11.8047 18.3372V14.1328L14.7191 14.8907V18.3359C14.7189 18.5119 14.6474 18.6806 14.5203 18.8049C14.3933 18.9293 14.2211 18.999 14.0416 18.9989ZM12.6964 18.1233H13.8252V15.5647L12.6964 15.2714V18.1233Z",
    fill: "#FF4F17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7587_10309",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.772549 0 0 0 0 0.839216 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7587_10309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7587_10309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7587_10309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 11,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/campaign_icon.cceb096c681c5f2756c98c235a89c52f.svg";
export { ForwardRef as ReactComponent };